export const formatSize = (size: number = 0, type: 'MB' | 'GB') => {
  const sizeInMB = size / 1024 / 1024
  if (type === 'MB') {
    return `${sizeInMB.toFixed()} MB`
  } 
    return `${(sizeInMB / 1024).toFixed()} GB`
  
}
